<div class="mb-0.5">
  @if (label) {
    <label
      [attr.for]="id()"
      class="block text-sm font-medium text-gray-900 dark:text-white mb-1"
    >
      {{ label }}
      @if (required) {
        <span class="text-red-500">*</span>
      }
    </label>
  }

  <textarea
    [id]="id()"
    [name]="id()"
    [rows]="rows"
    [formControl]="control"
    [placeholder]="placeholder"
    [value]="value"
    [attr.maxlength]="maxLength ?? null"
    (input)="onInput($event)"
    (blur)="onTouched()"
    class="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white placeholder-slate-400 dark:placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:text-gray-500 dark:disabled:border-gray-700 dark:disabled:bg-gray-800/20 transition-colors duration-200"
    [class.border-red-500]="errorMessage"
    [class.bg-gray-100]="disabled"
  ></textarea>

  <div class="mt-0.5 min-h-4 text-xs leading-tight text-red-500">
    @if (errorMessage) {
      <span>
        <i class="fa-solid fa-circle-exclamation mr-1"></i>
        {{ errorMessage }}
      </span>
    }
  </div>
</div>
